// tslint:disable:max-line-length
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateChild, UrlTree, Params } from '@angular/router';
import { RoutingHistoryService } from '../../routing/services/routing-history.service';
import { AuthHandlerService } from '../../auth/services/auth-handler.service';
import { IAuthConfig } from '../interfaces/auth-config.interface';
import { CoreAuthService } from '../services/core-auth.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class AuthGuard implements CanActivateChild {

    constructor(private authSvc: CoreAuthService, private router: Router, private authHandlerSvc: AuthHandlerService, private routingHistorySvc: RoutingHistoryService) { }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        const authConfig: IAuthConfig = childRoute.data.authConfig;
        if (authConfig) {
            if (this.authSvc.isUserAuthenticated()) {
                if (authConfig.authenticatedRedirectUrl) {
                    this.route(authConfig.authenticatedRedirectUrl, authConfig.preserveParams, childRoute.queryParams, state.url);
                    return false;
                }
                if (authConfig.roles && authConfig.roles.length > 0) {
                    if (this.authSvc.isUserMatchRoles(authConfig.roles)) {
                        return true;
                    } else {
                        this.doWhenNotAuthorized(childRoute, state.url);
                        return false;
                    }
                }
            } else {
                if (authConfig.notAuthenticatedRedirectUrl) {
                    this.route(authConfig.notAuthenticatedRedirectUrl, authConfig.preserveParams, childRoute.queryParams, state.url);
                    return false;
                } else {
                    if (authConfig.roles && authConfig.roles.length > 0) {
                        this.doWhenNotAuthorized(childRoute, state.url);
                        return false;
                    }
                }
            }
        }
        return true;
    }

    private doWhenNotAuthorized(route: ActivatedRouteSnapshot, returnUrl: string): void {
        if (this.routingHistorySvc.isFirstPage) {
            this.notAuthorizedRedirect(route, returnUrl);
        } else {
            this.authHandlerSvc.notAuthorizedSubject.next(returnUrl);
        }
    }

    private notAuthorizedRedirect(route: ActivatedRouteSnapshot, returnUrl: string) {
        if (!route) {
            throw new Error(`auth guard - Auth Config [notAuthorizedRedirectUrl] is missing for current route`);
        }

        const authConfig: IAuthConfig = route.data.authConfig;
        if (authConfig && authConfig.notAuthorizedRedirectUrl) {
            this.router.navigate([authConfig.notAuthorizedRedirectUrl], { skipLocationChange: authConfig.notAuthorizedSkipLocation || false, queryParams: authConfig.preserveParams ? { ...this.getReturnUrl(authConfig, returnUrl), ...route.queryParams } : this.getReturnUrl(authConfig, returnUrl) });
            return;
        }

        this.notAuthorizedRedirect(route.parent, returnUrl);
    }

    private getReturnUrl(authConfig: IAuthConfig, returnUrl: string): Params {
        if (authConfig.notAuthorizedSendReturnUrl) {
            return { 'returnUrl': returnUrl };
        }
        return;
    }

    private route(url: string, preserveParams: boolean, queryParams: Params, returnUrl: string): void {
        if (preserveParams) {
            this.router.navigate([url], { queryParams, state: { guardReturnUrl: returnUrl } });
        } else {
            this.router.navigate([url], { state: { guardReturnUrl: returnUrl } });
        }
    }
}
